module.exports = __webpack_public_path__ + "static/firemniporadenstvi-8388c3ed0609a1310eb54a3896a192b2.svg";